/*
  Bølgeskillene (.svg-top-curve) skal ha SAMME farge som seksjonen UNDER — det
  er intensjonen, og den står allerede skrevet i custom.css: «Wave fill color is
  set to match the next section's bg by design.»

  Problemet er at fargen har vært satt for hånd i hver av de 31 seksjonene som
  tegner en bølge. Det er en ANTAKELSE om hva som ligger under. Setter noen inn
  en ny seksjon i theme-editoren, eller bytter bakgrunnsfarge, er antakelsen
  feil — og man får en stripe i en tredje farge. (Det skjedde da kroppen-
  seksjonen ble satt inn under maskin-karusellen: bølgen var hvit, den nye
  seksjonen #FBF7F0.)

  Denne filen gjør fargen selvrettende: den leser den faktiske bakgrunnen til
  neste seksjon og maler bølgen i den. Da kan hvem som helst flytte om på
  seksjoner uten å vite at regelen finnes.
*/
(function () {
  'use strict';

  var GJENNOMSIKTIG = /^(transparent|rgba\(0,\s*0,\s*0,\s*0\))$/;

  function synlig(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.height > 4 && getComputedStyle(el).display !== 'none';
  }

  /* Fargen som FAKTISK males ved toppkanten av el.

     v1 tok den første ugjennomsiktige fargen den fant og stoppet på
     seksjonselementet. Det er feil når et fullbreddes barn maler over
     seksjonens egen bakgrunn: på FAQ-siden er seksjonen #FEF6EC, men
     .faq-section-head maler #FFFFFF over toppen. Da malte v1 bølgen i
     seksjonsfargen og ødela en kilde som var riktig fra før.

     Nå går vi så dypt vi kan LANGS KANTEN og beholder den SISTE fargen. */
  function kantfarge(el) {
    var funnet = null;
    var node = el;
    for (var i = 0; i < 8 && node; i++) {
      var bg = getComputedStyle(node).backgroundColor;
      if (!GJENNOMSIKTIG.test((bg || '').replace(/\s/g, ''))) funnet = bg;
      var pr = node.getBoundingClientRect();
      var neste = null;
      for (var k = 0; k < node.children.length; k++) {
        var b = node.children[k];
        var cs = getComputedStyle(b);
        if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') continue;
        var r = b.getBoundingClientRect();
        if (r.width < pr.width * 0.9 || r.height <= 8) continue;
        if (Math.abs(r.top - pr.top) > 2) continue;      // må ligge PÅ toppkanten
        neste = b; break;
      }
      node = neste;
    }
    if (funnet) return funnet;
    var opp = el.parentElement;
    while (opp && opp !== document.documentElement) {
      var c = getComputedStyle(opp).backgroundColor;
      if (!GJENNOMSIKTIG.test((c || '').replace(/\s/g, ''))) return c;
      opp = opp.parentElement;
    }
    return getComputedStyle(document.body).backgroundColor || null;
  }

  /* Neste synlige flate under seksjonen — også footeren, som ligger utenfor
     <main>. v1 ga opp når det ikke fantes en synlig nabo, og lot da en
     burgunder bølge stå igjen på en nesten svart footer (/pages/om-nono). */
  function nesteFlate(sec) {
    var node = sec;
    while (node && node !== document.body) {
      var s = node.nextElementSibling;
      while (s && !synlig(s)) s = s.nextElementSibling;
      if (s) return s;
      node = node.parentElement;
    }
    return null;
  }

  function synk() {
    var buer = document.querySelectorAll('.svg-top-curve');
    for (var i = 0; i < buer.length; i++) {
      var bue = buer[i];
      var sec = bue.closest('.shopify-section') || bue.parentElement;
      if (!sec) continue;
      var neste = nesteFlate(sec);
      if (!neste) continue;
      var farge = kantfarge(neste);
      if (!farge) continue;
      var former = bue.querySelectorAll('path, polygon, rect');
      for (var j = 0; j < former.length; j++) {
        var f = former[j];
        // rør ikke former som er bevisst gjennomsiktige (skygger, masker)
        var naa = f.getAttribute('fill') || getComputedStyle(f).fill;
        if (naa === 'none' || /rgba\(.*,\s*0\)$/.test(naa)) continue;
        // aksentbanen (opacity 0.15) er en designdetalj som ligger under
        // hovedbanen — den skal beholde sin egen farge
        var op = parseFloat(f.getAttribute('opacity') || getComputedStyle(f).opacity || '1');
        if (op < 0.9) continue;
        f.setAttribute('fill', farge);
        f.style.fill = farge;
      }
      bue.setAttribute('data-curve-synced', farge);
    }
  }

  function start() {
    synk();
    // Bilder og webfonter kan endre høyder og dermed hvilken seksjon som er
    // «neste synlige» — kjør en gang til når alt er lastet.
    window.addEventListener('load', synk, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme-editoren: seksjoner legges til, fjernes og flyttes uten reload.
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder',
   'shopify:section:select'].forEach(function (e) {
    document.addEventListener(e, function () { setTimeout(synk, 0); });
  });

  window.nonoCurveSync = synk;   // for feilsøking i konsollen
})();
